import { motion } from 'motion/react'
import { Flex } from '../Primitives'

const Dot = ({ animationDelay = 0 }) => {
	return (
		<motion.div
			style={{
				display: 'inline-block',
				width: 10,
				height: 10,
				borderRadius: 5,
				margin: '10px 2px',
				backgroundColor: '#555',
			}}
			animate={{
				opacity: [1, 0.5, 0.5],
				y: [0, 5, 5],
			}}
			transition={{
        delay: animationDelay,
        duration: 0.8,
        ease: 'easeOut',
        repeat: Infinity,
        repeatType: 'reverse',
        times: [0, 0.4, 1],
      }}
		/>
	)
}

/**
 * LoadingIcon component.
 *
 * This component renders a loading animation icon.
 *
 * @component
 * @example
 * // Usage example:
 * <LoadingIcon />
 *
 * @returns {JSX.Element} The LoadingIcon component.
 */
export const LoadingIcon = ({ count = 4, ...props }) => {
	const fingers = Array.from({ length: count }, (_, index) => index * 0.15)

	return (
		<Flex {...props}>
			{fingers.map((finger) => {
				const key = `bnb__loading__finger--${finger}`
				return <Dot key={key} animationDelay={finger} />
			})}
		</Flex>
	)
}
